// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__NDDof","logo":"Navbar_logo__PorvY","navLinks":"Navbar_navLinks__iuijO","navItem":"Navbar_navItem__HnuhZ"};